import gql from 'graphql-tag'
 
export const CHECK_MODULO_VISTO = gql `
subscription CheckModuloVisto(
  $idEmpresa: String!
  $idUsuario: String!
){
  CheckModuloVisto(id_usuario: $idUsuario, id_empresa: $idEmpresa) {
    modulo {
      id_detalle
      nombre_modulo
      descripcion_modulo
      posicion_pantalla
      imagen_url
      url_menu_inactivo
      url_menu_activo
      ruta_web
      moduloGeneral {
        id_modulo
        nombre_modulo
        descripcion_modulo
        id_app
        id_admin
        is_web
        tipo_check
      }
      id_estado_fk
      destacado
      posicion_intranet
    }
    no_vistos
  }
}`